import { Controller } from '@hotwired/stimulus'

// This controller only hides in css so that there is no impact on SEO.
// it toggles line-clamp. Make sure the maxLines value matches a line-clamp-${value} class

export default class LineCropController extends Controller {
  static targets = ['button', 'text'];

  static values = {
    maxLines: Number,
  }

  connect() {
    const intervalId = setInterval(() => {
      if (this.isDisplayed()) {
        this.checkAndToggleCrop();
        clearInterval(intervalId);
      }
    }, 200);
  }

  checkAndToggleCrop() {
    const displayedLines = this.countDisplayedLines();
    if (displayedLines > this.maxLinesValue) {
      this.toggleCrop();
      this.buttonTarget.classList.remove('d-none')
    }
  }

  countDisplayedLines() {
    const containerHeight = this.textTarget.offsetHeight;
    const lineHeight = parseInt(window.getComputedStyle(this.textTarget).lineHeight, 10);
    const displayedLines = Math.floor(containerHeight / lineHeight);

    return displayedLines;
  }

  isDisplayed() {
    const rect = this.element.getBoundingClientRect();
    return (
      rect.top != 0 || rect.bottom !=0 || rect.left !=0 || rect.right !=0
    );
  }

  toggleCrop() {
    if(this.textTarget.classList.contains('line-clamp')) {
      this.textTarget.classList.remove('line-clamp', `line-clamp-${this.maxLinesValue}`);
      this.element.classList.add('is-expanded');
      this.buttonTarget.ariaExpanded = true;
    } else {
      this.textTarget.classList.add('line-clamp', `line-clamp-${this.maxLinesValue}`);
      this.element.classList.remove('is-expanded');
      this.buttonTarget.ariaExpanded = false;
    }
  }
}
